/**
 * Types de comparaison
 */
export enum TypeComparaison {
    /** Enumération **/
    LIKE,
    EQUAL,
    NOT_EQUAL,
    GREATER,
    GREATER_EQUAL,
    LESS,
    LESS_EQUAL,
    BETWEEN,
    IN,
    NOT_IN
}
